module.exports = __webpack_public_path__ + "img/badge-list-thumb-104.e9b1a91c.png";